module.exports = __webpack_public_path__ + "assets/img/LTC035.eb30cb05.png";